import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_BN: MRT_Localization = {
  language: "bn",
  actions: "ক্রিয়াকলাপ",
  and: "এবং",
  cancel: "বাতিল",
  changeFilterMode: "ফিল্টার মোড পরিবর্তন করুন",
  changeSearchMode: "অনুসন্ধান মোড পরিবর্তন করুন",
  clearFilter: "ফিল্টার সাফ করুন",
  clearSearch: "অনুসন্ধান সাফ করুন",
  clearSelection: "নির্বাচন সাফ করুন",
  clearSort: "সাজানো সাফ করুন",
  clickToCopy: "কপি করতে ক্লিক করুন",
  copy: "কপি",
  collapse: "সংকুচিত করুন",
  collapseAll: "সব সংকুচিত করুন",
  columnActions: "কলাম ক্রিয়াকলাপ",
  copiedToClipboard: "ক্লিপবোর্ডে কপি করা হয়েছে",
  dropToGroupBy: "গ্রুপ করতে {column} এ ড্রপ করুন",
  edit: "সম্পাদনা",
  expand: "প্রসারিত করুন",
  expandAll: "সব প্রসারিত করুন",
  filterArrIncludes: "অন্তর্ভুক্ত",
  filterArrIncludesAll: "সব অন্তর্ভুক্ত",
  filterArrIncludesSome: "অন্তর্ভুক্ত",
  filterBetween: "মধ্যে",
  filterBetweenInclusive: "অন্তর্ভুক্ত মধ্যবর্তী",
  filterByColumn: "{column} দ্বারা ফিল্টার করুন",
  filterContains: "অন্তর্ভুক্ত",
  filterEmpty: "খালি",
  filterEndsWith: "দিয়ে শেষ হয়",
  filterEquals: "সমান",
  filterEqualsString: "সমান",
  filterFuzzy: "ফাজি",
  filterGreaterThan: "এর চেয়ে বড়",
  filterGreaterThanOrEqualTo: "এর চেয়ে বড় বা সমান",
  filterInNumberRange: "মধ্যে",
  filterIncludesString: "অন্তর্ভুক্ত",
  filterIncludesStringSensitive: "অন্তর্ভুক্ত",
  filterLessThan: "এর চেয়ে ছোট",
  filterLessThanOrEqualTo: "এর চেয়ে ছোট বা সমান",
  filterMode: "ফিল্টার মোড: {filterType}",
  filterNotEmpty: "খালি নয়",
  filterNotEquals: "সমান নয়",
  filterStartsWith: "দিয়ে শুরু হয়",
  filterWeakEquals: "সমান",
  filteringByColumn: "{column} দ্বারা ফিল্টারিং - {filterType} {filterValue}",
  goToFirstPage: "প্রথম পেজে যান",
  goToLastPage: "শেষ পেজে যান",
  goToNextPage: "পরবর্তী পেজে যান",
  goToPreviousPage: "পূর্ববর্তী পেজে যান",
  grab: "ধরুন",
  groupByColumn: "{column} দ্বারা গ্রুপ করুন",
  groupedBy: "দ্বারা গ্রুপ করা ",
  hideAll: "সব লুকান",
  hideColumn: "{column} কলাম লুকান",
  max: "সর্বোচ্চ",
  min: "সর্বনিম্ন",
  move: "স্থানান্তর",
  noRecordsToDisplay: "প্রদর্শনের জন্য কোন রেকর্ড নেই",
  noResultsFound: "কোন ফলাফল পাওয়া যায়নি",
  of: "এর",
  or: "বা",
  pin: "পিন করুন",
  pinToLeft: "বামে পিন করুন",
  pinToRight: "ডানে পিন করুন",
  resetColumnSize: "কলাম আকার রিসেট করুন",
  resetOrder: "ক্রম রিসেট করুন",
  rowActions: "সারি ক্রিয়াকলাপ",
  rowNumber: "#",
  rowNumbers: "সারি নম্বর",
  rowsPerPage: "প্রতি পেজে সারি",
  save: "সংরক্ষণ",
  search: "অনুসন্ধান",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} এর মধ্যে {rowCount} সারি নির্বাচিত",
  select: "নির্বাচন",
  showAll: "সব দেখান",
  showAllColumns: "সব কলাম দেখান",
  showHideColumns: "কলাম দেখান/লুকান",
  showHideFilters: "ফিল্টার দেখান/লুকান",
  showHideSearch: "অনুসন্ধান দেখান/লুকান",
  sortByColumnAsc: "{column} দ্বারা আরোহী ক্রমে সাজান",
  sortByColumnDesc: "{column} দ্বারা অবরোহী ক্রমে সাজান",
  sortedByColumnAsc: "{column} দ্বারা আরোহী ক্রমে সাজানো",
  sortedByColumnDesc: "{column} দ্বারা অবরোহী ক্রমে সাজানো",
  thenBy: ", তারপর ",
  toggleDensity: "ঘনত্ব টগল করুন",
  toggleFullScreen: "পূর্ণস্ক্রিন টগল করুন",
  toggleSelectAll: "সব নির্বাচন টগল করুন",
  toggleSelectRow: "সারি নির্বাচন টগল করুন",
  toggleVisibility: "দৃশ্যমানতা টগল করুন",
  ungroupByColumn: "{column} দ্বারা গ্রুপ বাতিল করুন",
  unpin: "আনপিন করুন",
  unpinAll: "সব আনপিন করুন",
};
